module.exports = __webpack_public_path__ + "img/wtb5.e5791b85.png";